import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 500px;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p`
  color: #101828;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin-left: 20px;
`;

export const Button = styled(IconButton)``;
